import React from "react";
import { useLanguage } from "../Router/LanguageContext";

export default function LinkSlider() {
  const { dictionary } = useLanguage();

  const services = [
    dictionary?.renewableEnergy,
    dictionary?.oilGasServices,
    dictionary?.epcInfrastructure,
  ];
  return (
    <>
      <div className="outerShadeTrusted">
        <div className="container-fluid overflow-hidden">
          <div className="row">
            <div className="col-md-12">
              <div className="trustedWrapper">
                <div className="trustedServices">
                  {[...services, ...services, ...services].map(
                    (item, index) => (
                      <React.Fragment key={index}>
                        <p className="m-0 f-s-24">{item}</p>
                        <img src="/assets/img/Star.svg" alt="" />
                      </React.Fragment>
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
